import axios from "axios";

export function logoutAPI() {
  const metaData = {
    withCredentials: true,
  };

  return new Promise((resolve) => {
    axios
      .post(`${process.env.REACT_APP_BACKEND}/applogout`, {}, metaData)
      .then((response) => {
        resolve(response.status);
      })
      .catch((e) => {
        resolve(e.status);
      });
  });
}